module.exports = __webpack_public_path__ + "img/1508270812.4c307c68.jpg";